import { AbstractLocalDataAccessLayer } from "@/lib/utility/data/local-data-access-layer.abstract";
import { MrfiktivPartnerCustomerUserViewModelGen } from "@/services/mrfiktiv/v1/data-contracts";

export const CustomerAccountDataAccessLayer =
  new (class extends AbstractLocalDataAccessLayer<MrfiktivPartnerCustomerUserViewModelGen> {
    protected mapEntity(entity: MrfiktivPartnerCustomerUserViewModelGen): MrfiktivPartnerCustomerUserViewModelGen {
      return entity;
    }

    getIdentifier(entity: MrfiktivPartnerCustomerUserViewModelGen): string {
      return entity.id;
    }
  })();
